import { getStore } from '../store/Store';
import type MailboxInfo from 'owa-client-ids/lib/schema/MailboxInfo';
import { mutatorAction } from 'satcheljs';

export const setDeeplinkId = mutatorAction(
    'setDeeplinkId',
    function (itemId: string, mailboxInfo?: MailboxInfo) {
        getStore().deeplinkId = {
            id: itemId,
            isConversation: false,
            mailboxInfo: mailboxInfo,
        };
    }
);
